<template>
  <div id="ProjectAddress">
    <el-row>
      <el-col :span="span">
        <el-select
         style="margin-right:10px"
          v-model="addressDetail.province1"
          @change="changeProvince"
          placeholder="-- 请选择省份 --"
          filterable
        >
          <el-option
            v-for="item in provinceList"
            :key="item.code"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="span">
        <el-select
          style="margin-right:10px"
          v-model="addressDetail.city1"
          @change="changeCity"
          placeholder="-- 请选择市 --"
          filterable
        >
          <el-option
            v-for="item in cityList"
            :key="item.code"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="span">
        <el-select
          style="margin-right:10px"
          v-model="addressDetail.area1"
          @change="changeArea"
          placeholder="-- 请选择区或县 --"
          filterable
        >
          <el-option
            v-for="item in areaList"
            :key="item.code"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="span1">
        <el-input
        
          v-model="addressDetail.address1"
          placeholder="-- 详细地址 --"
          @change="handleCurrentChange"
        ></el-input>
      </el-col>
    </el-row>
  </div>
</template>
 
<script>
import { addressList } from "./ProjectAddress";
import {
  getProvinceService, //查询省列表
  getCityService //查询市区列表
} from "../../../services/sysSettingService";
export default {
  name: "ProjectAddress",
  components: {},
  props: {
    province: {
      default: "",
      type: String
    },
    city: {
      default: "",
      type: String
    },
    area: {
      default: "",
      type: String
    },
    address: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      provinceList: [], // 省份列表
      cityList: [], // 城市列表
      areaList: [], // 区/县列表
      provinceCode: "", // 省份编码
      cityCode: "", // 城市编码
      areaCode: "", // 区/县编码
      cityFlag: false, // 避免重复请求的标志
      provinceFlag: false,
      areaFlag: false,
      span:5,
      span1:9,
      addressDetail: {
        province1: "", // 省
        city1: "", // 市
        area1: "", //区
        address1: "" // 详细地址
      }
    };
  },
  watch: {
    // addressCode: {
    //   deep: true,
    //   immediate: true,
    //   handler(newVal) {
    //     if (newVal) {
    //       this.addressCodeToList(newVal);
    //     } else {
    //       this.$nextTick(() => {
    //         this.reset();
    //       });
    //     }
    //   }
    // },
    province(newVal) {
      this.addressDetail.province1 = newVal;
    },
    city(newVal) {
      this.addressDetail.city1 = newVal;
    },
    area(newVal) {
      this.addressDetail.area1 = newVal;
    },
    address(newVal) {      
      this.addressDetail.address1 = newVal;
    }
  },

  created() {
    this.getProvinces();
  },

  methods: {
    handleCurrentChange(val) {
      // this.addressDetail.province1=this.province;
      // this.addressDetail.city1=this.city;
      // this.addressDetail.area1=this.area;
      // this.addressDetail.address1=this.address;
      this.$emit("getAddressDetail", this.addressDetail);
    },
    /**
     * 获取数据
     * @param {Array} array 列表
     * @param {String} url 请求url
     * @param {String} code 编码(上一级编码)
     */
    fetchData(array, code) {
      array.splice(0, array.length, ...this.addressList);
      //    this.$http({
      //     method: 'get',
      //     url: url + '/' + code
      //    })
      //    .then(res => {
      //     if (res.data.code === this.API.SUCCESS) {
      //      let body = res.data.body || []
      //      array.splice(0, array.length, ...body)
      //     }
      //    })
      //    .catch(err => {
      //     console.log(err)
      //    })
      //    .finally(res => {
      //    })
    },
    // 根据国家编码获取省份列表
    getProvinces() {
      getProvinceService()
        .then(res => {
          if (res.code == 10000000) {
            this.provinceList = res.data; //省列表
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        })
        .catch(error => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定"
          });
        });
    },
    // 城市列表
    changeProvince(val) {
      this.addressDetail.city1 = "";
      this.addressDetail.area1 = "";
      let obj = {};
      obj = this.provinceList.find(item => {
        return item.name == val;
      });

      let code = obj.code;
      let param = {};
      param.code = code;
      getCityService(param)
        .then(res => {
          if (res.code == 10000000) {
            this.cityList = res.data; //市列表
            this.areaList=[];
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        })
        .catch(error => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定"
          });
        });
      this.$emit("getAddressDetail", val);
    },
    // 根据省份编码获取城市列表
    getCities() {
      if (this.cityFlag) {
        return;
      }
      if (this.provinceCode) {
        this.fetchData(this.cityList, this.provinceCode);
        this.cityFlag = true;
      }
    },
    // 城市修改，拉取对应区域列表
    changeCity(val) {
      this.addressDetail.area1 = "";
      let obj = {};
      obj = this.cityList.find(item => {
        return item.name == val;
      });

      let code = obj.code;
      let param = {};
      param.code = code;
      getCityService(param)
        .then(res => {
          if (res.code == 10000000) {
            this.areaList = res.data; //市列表
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        })
        .catch(error => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定"
          });
        });
      // this.$emit("getAddressDetail", val);
      this.$emit("getAddressDetail", this.addressDetail);
    },
    // 根据城市编码获取区域列表
    getAreas() {
      if (this.areaFlag) {
        return;
      }
      if (this.cityCode) {
        this.fetchData(this.areaList, this.API.area, this.cityCode);
      }
    },
    // 区域修改
    changeArea(val) {
      // this.$emit("getAddressDetail", val);
      this.$emit("getAddressDetail", this.addressDetail);
    },
    // 重置省市区/县编码
    reset() {
      (this.provinceCode = ""), (this.cityCode = ""), (this.areaCode = "");
    },
    // 地址编码转换成省市区列表
    addressCodeToList(addressCode) {
      if (!addressCode) return false;
      this.$http({
        method: "get",
        url: this.API.addressCode + "/" + addressCode
      })
        .then(res => {
          let data = res.data.body;
          if (!data) return;
          if (data.provinceCode) {
            this.provinceCode = data.provinceCode;
            this.fetchData(this.cityList, this.API.city, this.provinceCode);
          } else if (data.cityCode) {
            this.cityCode = data.cityCode;
            this.fetchData(this.areaList, this.API.area, this.cityCode);
          } else if (data.areaCode) {
            this.areaCode = data.areaCode;
          }
        })
        .finally(res => {});
    }
  }

  // watch: {
  //   addressCode: {
  //     deep: true,
  //     immediate: true,
  //     handler(newVal) {
  //       if (newVal) {
  //         this.addressCodeToList(newVal);
  //       } else {
  //         this.$nextTick(() => {
  //           this.reset();
  //         });
  //       }
  //     }
  //  }
  // }
};
</script>
 
<style lang="less" scoped>
</style>